import React from 'react';
import styled from 'styled-components';
import { mediaBreakpoint } from '@root/src/services/responsiveProvider';
import SerieSidePanel from './SerieSidePanel';

const SerieContentWithSidePanel = ({ children }) => (
  <Container>
    <StyledSerieSidePanel />
    {children}
  </Container>
);

export default SerieContentWithSidePanel;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 40px;

  ${mediaBreakpoint.tablet} {
    flex-direction: column;
  }
`;

const StyledSerieSidePanel = styled(SerieSidePanel)`
  margin-right: 100px;
  /* otherwise flex will try to shrink our sidepanel as much as possible */
  min-width: 351px;
  max-width: 351px;

  ${mediaBreakpoint.tablet} {
    flex-direction: column;
    min-width: unset;
    max-width: unset;
    width: 100%;
    margin-bottom: 40px;
  }

`;
